export default {
  getExternalOrderRequestStatuses: state => state.externalOrderRequestStatuses,
  getPartnerOrderRequests: state => state.partnerOrderRequests,
  getPartnerOrderRequest: state => state.partnerOrderRequest,
  getPartnerOrderRequestsTotal: state => state.partnerOrderRequestsTotal,
  getPartnerOrderRequestsLimit: state => state.partnerOrderRequestsLimit,
  getPartnerOrderRequestsPage: state => state.partnerOrderRequestsPage,
  getPartnerOrderRequestStatusTotals: state => state.partnerOrderRequestStatusTotals,
  getAllowedCustomers: state => state.allowedCustomers,
  getAllowedOrderTypes: state => state.allowedOrderTypes,
  getPartnerOrderRequestInstruction: state => state.partnerOrderRequestInstruction,
  getDispatcherReviewRequests: state => state.dispatcherReviewRequests,
  getDispatcherReviewRequest: state => state.dispatcherReviewRequest,
  getDispatcherReviewRequestsTotal: state => state.dispatcherReviewRequestsTotal,
  getDispatcherReviewRequestsLimit: state => state.dispatcherReviewRequestsLimit,
  getDispatcherReviewRequestsPage: state => state.dispatcherReviewRequestsPage,
  getDispatcherReviewPendingTotal: state => state.dispatcherReviewPendingTotal,
  getDispatcherReviewStatusTotals: state => state.dispatcherReviewStatusTotals,
}
